import React, { useEffect } from "react"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import {  useLocation, useNavigate } from "react-router-dom"
import { ShimmerThumbnail } from "react-shimmer-effects"
import {
  Badge,
  BreadcrumbItem,
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  Table,
} from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import BackButton from "components/Shared/BackButton"
import { getFaqDetails } from "store/actions/faqAction"
import isPermissionEnabled from "common/isPermissionEnabled"
import { useTranslation } from "react-i18next"

const FaqDetails = () => {
  const { t } = useTranslation()

  document.title = t("Faq Details | Namq")
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const id = searchParams.get("id")
  const { loading, faqDetails } = useSelector(state => state.Faqs)

  const { userRole, accountType } = useSelector(state => state.Login)

  useEffect(() => {
    const isPermissionView = isPermissionEnabled(
      userRole,
      18,
      "faq_1",
      accountType
    )
    if (!isPermissionView) {
      navigate("/dashboard")
    }
  }, [])

  useEffect(() => {
    getOldValues()
  }, [])

  const getOldValues = () => {
    const payload = {
      id,
    }
    dispatch(getFaqDetails(payload))
  }

  return (
    <div className="page-content category_page">
      <div className="container-fluid">
        <Breadcrumbs />
        {loading ? (
          <Card>
            <CardBody>
              <Row>
                <Col lg={12}>
                  <ShimmerThumbnail height={310} rounded />
                </Col>
              </Row>
            </CardBody>
          </Card>
        ) : (
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <CardTitle className="mb-3 d-flex align-items-center">
                    <BackButton /> {t("FAQ Details")}
                  </CardTitle>
                  <div className="table-responsive">
                    {Object.values(faqDetails).length === 0 ? (
                      <p className="text-center my-3">
                        {t("No FAQ details found")}
                      </p>
                    ) : (
                      <Table className="table-nowrap mb-0">
                        <tbody>
                          <tr>
                            <th scope="row">{t("Id")}</th>
                            <td>{faqDetails._id}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Title(English)")}</th>
                            <td>{faqDetails.title || "-"}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Title(عربي)")}</th>
                            <td>{faqDetails.titleAr || "-"}</td>
                          </tr>

                          <tr>
                            <th scope="row">{t("Description(English)")}</th>
                            <td>{faqDetails.description || "-"}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Description(عربي)")}</th>
                            <td>{faqDetails.descriptionAr || "-"}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Status")}</th>
                            <td>
                              {faqDetails.status === 1 ? (
                                <Badge className="bg-success">
                                  {t("Active")}
                                </Badge>
                              ) : (
                                <Badge className="bg-danger">
                                  {t("Deactive")}
                                </Badge>
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      </div>
    </div>
  )
}

export default FaqDetails
